export const POLYGON_CHAIN_ID = 137;
export const MUMBAI_CHAIN_ID = 80001;

export const TEXT_TWITTER =
  "I’ve just minted my first lands in @Coderblock metaverse! 🌎 \n Go mint yours 👉🏼 https://metaverse.coderblock.com/lands";

export const POLYGON_NETWORK_URL = "https://matic-mumbai.chainstacklabs.com";

export const GRID_W_H = 210;

export const PAYMENT_TOKEN_INDEX = 3;
export const USDC_TOKEN_INDEX = 2;
export const USDT_TOKEN_INDEX = 3;

export const PRICE = "495";

export const MAX_GAS_LIMIT = 20000000;
export const MIN_GAS_LIMIT = 1000000;
export const SURPLUS = 75000;

export const TOPIC_RECLAIM_LAND =
  "0xbd2dd4b055c76ced605cdc651a7bf9178689c0ce8736c4305619761313473c9c";

let landRegistry;
let estateRegistry;
let rentRegistry;
let blockRegistry;
let candyMachine;
let USDC;
let USDT;
let network;
let nameNetwork;
let networkURL;
let nameToken;
let tokenSYMB;
let BlockExplorer;
let endopointAPI;
let endopointAPIV1;
let environment;
let unity_map_base_path_build;
let unity_map_version_build;
let endopointCheckoutAPI;
let environmentUnity;
let clientIdPaypal = null;

const hostname = window && window.location && window.location.hostname;

if (hostname === "land.coderblock.com") {
  landRegistry = "0xF4b0c69d94F3A2A26B7E37F9876BaaB99eb4cB77";
  estateRegistry = "0x7Bff9377E0093b385c3f8AB1Ad6D2BD79f07B857";
  rentRegistry = "0xA0f4F45aD99479Ba9e1DA2b16a8E8dF73B37d58b";
  blockRegistry = "0x3255D2B0BC6461Ba145Fc99D5682F42e288d07DA";
  candyMachine = "0x4043BBa8C038eD7ad8C7D851da1B69aB2d3133bF";
  USDC = "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174";
  USDT = "0xc2132d05d31c914a87c6611c10748aeb04b58e8f";
  network = POLYGON_CHAIN_ID;
  nameNetwork = "Polygon Mainnet";
  networkURL = "https://polygon.llamarpc.com";
  nameToken = "MATIC";
  tokenSYMB = "MATIC";
  BlockExplorer = "https://polygonscan.com";
  endopointAPI = "https://api.coderblock.com/v2/";
  endopointAPIV1 = "https://api.coderblock.com/v1/";
  endopointCheckoutAPI = "https://checkout.coderblock.com/";
  environment = "https://coderblock.com/";
  environmentUnity = "prod";
  unity_map_base_path_build =
    "https://coderblock-assets.akamaized.net/build/unity/v2/mapseason1/prod/";
  unity_map_version_build = "0.0.66";

  clientIdPaypal = "AUUr8A1xMyzdWnxmIxwB9Q6vWJTVu6QL9kC4JuWbK8_pOMb7R1Wpojr5pUkp93Hodr3h3N4Ctr1UM85M";
} else if (hostname === "land-qa.coderblock.com" || hostname === "localhost") {
  landRegistry = "0xB726a502018d514f32294D61E1fA601c2CD57BAE";
  estateRegistry = "0x8E029635e4d7C7F07909C3fAC1Be3DA9a623A67d";
  rentRegistry = "0xA0f4F45aD99479Ba9e1DA2b16a8E8dF73B37d58b";
  blockRegistry = "0x1c4233dCe73aDd9d087d263e2554a82CEFee7b8A";
  candyMachine = "0x83efBf84AB4cefE58115FC8594739AE8759b4769";
  USDC = "0x86b3B1e55763E1E440f91B977D1C4e59f34c0f94";
  USDT = "0x86b3B1e55763E1E440f91B977D1C4e59f34c0f94";
  network = MUMBAI_CHAIN_ID;
  nameNetwork = "Mumbai";
  nameToken = "MATIC";
  networkURL = "https://matic-mumbai.chainstacklabs.com";
  tokenSYMB = "MATIC";
  BlockExplorer = "https://mumbai.polygonscan.com/";
  endopointAPI = "https://api-qa.coderblock.com/v2/";
  endopointAPIV1 = "https://api-qa.coderblock.com/v1/";
  endopointCheckoutAPI = "https://checkout-qa.coderblock.com/";
  environment = "https://qa.coderblock.com/";
  environmentUnity = "qa";
  unity_map_base_path_build =
    "https://coderblock-assets.akamaized.net/build/unity/v2/mapseason1/qa/";
  unity_map_version_build = "0.0.66";

  clientIdPaypal = "Acci9zbQpt0CeG5tohYySe4ckiGlros7W9EohbDmQ4R8_MvL__fMOliB2PP185m9I5g05nRqHcrzMSXO";
}


export const CLIENT_ID_PAYPAL = clientIdPaypal
export const LAND_REGISTRY = landRegistry;
export const ESTATE_REGISTRY = estateRegistry;
export const RENT_REGISTRY = rentRegistry;
export const BLOCK_REGISTRY = blockRegistry;
export const CANDY_MACHINE = candyMachine;
export const USDC_REGISTRY = USDC;
export const USDT_REGISTRY = USDT;
export const NETWORK = network;
export const NETWORK_NAME = nameNetwork;
export const TOKEN_NAME = nameToken;
export const NETWORK_URL = networkURL;
export const NETWORK_SYMB = tokenSYMB;
export const NETWORK_EXPLORER = BlockExplorer;
export const API_ENDPOINT = endopointAPI;
export const API_ENDPOINT_V1 = endopointAPIV1;
export const API_CHECKOUT = endopointCheckoutAPI;
//export const API_CHECKOUT = "http://localhost:5252/";
export const ENVIRONMENT = environment;
export const ENVIRONMENTUNITY = environmentUnity;
export const UNITY_MAP_BASE_PATH = unity_map_base_path_build;
export const UNITY_MAP_VERSION = unity_map_version_build;
export const PRICE_LAND = 495;
